<template>
    <template-layout v-if="memberInformation" :breadCrumbList="breadcrumbComputed">
        <div class="py-12 px-4">
            <nav class="my-2 flex justify-between">
                <h1 class="text-2xl text-theme-1">
                แผนการให้ความช่วยเหลือ : {{getProbDesc}}
                </h1>
            </nav>
            <div class="w-1/6 h-1/6 mx-auto" v-if="pageLoading">
                <LoadingIcon icon="oval" class="w-8 h-8 text-white" />
            </div>
            <template v-else>
                <div class="mt-8">
                    <!-- <CustomTab
                        @currentTab="summaryTabChange"
                        :id="'summary-tab'"
                        :currentTabText="currentSummaryTabText"
                        :TabArray="[
                            {tab: 'critical', name: 'แผนระยะวิกฤต'},
                            {tab: 'short', name: 'แผนระยะสั้น'},
                            {tab: 'continuous', name: 'แผนระยะต่อเนื่อง'},
                        ]"
                    >
                        <template v-slot:tab-content>
                            <PlanTab :dataList="memberInformation" :activeTab="currentSummaryTab" @complete="getMemberInformation"/>
                        </template>
                        <template v-slot:nav-right>
                        <div class="text-center">
                            <a
                                class="btn btn-primary"
                                href="javascript:;"
                                @click="modalStatus = true"
                            >
                                <PlusIcon class="h-3 w-3 mr-1" />
                                เพิ่ม
                            </a>
                        </div>
                        </template>
                    </CustomTab> -->
                    <CustomAccordion
                        :isOpen="true"
                        :iconText="false"
                        :accordion-id="`${acc.tab}`"
                        customMode
                        v-for="acc in planArray"
                        :key="acc"
                        :showIcon="false"
                    >
                        <template v-slot:header-content>
                            <div class="text-base font-semibold text-theme-37 w-full py-2">
                                <div>{{acc.name}}</div>
                            </div>
                        </template>
                        <template v-slot:outside-header-button v-if="getAllowActionByCurrRole('create-problem-plan')">
                            <div class="absolute right-0 top-0">
                                <button
                                    class="btn btn-primary"
                                    @click="modalStatus = true, currentSummaryTabText = acc.name, currentSummaryTab = acc.tab"
                                    :disabled="memberInformation.prob_summary[route.query.prob][memberInformation.prob_summary[route.query.prob].findIndex(x=>x.code == route.query.code)].status == 3"
                                >
                                    <PlusIcon class="h-3 w-3 mr-1" />
                                    เพิ่ม
                                </button>
                            </div>
                        </template>
                        <template v-slot:body-content>
                            <hr>
                            <PlanTab :dataList="memberInformation" :activeTab="acc.tab"  @openViewModal="openViewModal" @openAddModal="openAddModal" @closeCase="closeCaseEvent"/>
                        </template>
                    </CustomAccordion>
                </div>
            </template>
        </div>
         <selectDataConnectionForSol 
  :openModalStatus="showConnectModal"   
  :infoData="planForm"
  :allowedSystems="allowedSystems"
  :validate="validate.$invalid"
  @update:openModalStatus="showConnectModal = $event"
  @handleSaveModal="handleSaveModal"/>

        <modal-layout v-model="modalStatus" :headerTitle="`เพิ่ม${currentSummaryTabText}`" @click:save="handleSelectToSentOtherConnection" @click:cancel="clearModal" :id="'plan-process'" :isDone="isDone" v-if="getAllowActionByCurrRole('create-problem-plan')">
            <slot>
                <div>
                    <div class="font-medium text-base my-2 font-bold text-theme-20">
                        แนวทางการแก้ไข
                    </div>
                    <div class="form-inline">
                        <label for="plan-category" class="form-label sm:w-40">ประเภทแนวทางการแก้ไข<span class="text-red"> *</span></label>
                        <div class="flex-1">
                            <v-select
                                data-test="plan-category-process"
                                v-model="validate.category.$model"
                                :options="problemProcessCategory"
                                :clearable="false"
                                :searchable="false"
                                placeholder="กรุณาเลือกประเภทแนวทางการแก้ไข"
                                :class="{ 'border-1 border-theme-24 rounded-md': validate.category.$error}"
                                id="plan-category"
                                @option:selected="getProcessSolution"
                            >
                                <template #open-indicator="{ attributes }">
                                    <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                                </template>
                            </v-select>
                            <template v-if="validate.category.$error">
                                <div class="text-theme-24 mt-1 text-xs">
                                {{validate.category.required.$message}}
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="form-inline mt-5">
                        <label for="horizontal-form-2" class="form-label sm:w-40">แนวทางการแก้ไข<span class="text-red"> *</span></label>
                        <div class="flex-1">
                            <v-select
                                data-test="plan-process"
                                v-model="validate.process.$model"
                                :options="dataOption"
                                :clearable="false"
                                :searchable="false"
                                placeholder="กรุณาเลือกแนวทางการแก้ไข"
                                :class="{ 'border-1 border-theme-24 rounded-md': validate.process.$error}"
                                label="sol_des"
                                :reduce="label => label"
                                @option:selected="solutionSelected">
                                <template #open-indicator="{ attributes }">
                                    <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                                </template>
                                <template #no-options="">
                                    <p class="text-sm font-normal text-gray-500">
                                        ไม่พบข้อมูล
                                    </p>
                                </template>
                            </v-select>
                            <template v-if="validate.process.$error">
                                <div class="text-theme-24 mt-1 text-xs">
                                {{validate.process.required.$message}}
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="form-inline mt-5" v-if="form.process && form.process.sol_des == 'อื่นๆ'">
                        <label for="sub-agency" class="form-label sm:w-40">อื่นๆ</label>
                        <input id="sub-agency" type="text" v-model="planForm.sol_other" class="form-control" placeholder="ระบุ" />
                    </div>
                    <div class="font-medium text-base my-2 font-bold text-theme-20">
                        รายละเอียด
                    </div>
                    <div class="form-inline items-baseline">
                        <label for="horizontal-form-2" class="form-label sm:w-40">รายละเอียด</label>
                        <textarea id="horizontal-form-2" placeholder="กรุณาระบุรายละเอียดปัญหาและแนวทางแก้ไข" class="form-control" style="min-height: 60px;resize: none;" v-model="planForm.sol_detail"/>
                    </div>
                    <div class="font-medium text-base my-2 font-bold text-theme-20">
                        หน่วยงานที่ส่งต่อ
                    </div>
                    <div class="form-inline">
                        <label for="horizontal-form-2" class="form-label sm:w-40">หน่วยงาน<span class="text-red"> *</span></label>
                        <div class="flex-1">
                            <v-select
                                data-test="agency"
                                v-model="validate.agency.$model"
                                :options="organizeOption"
                                :clearable="false"
                                :searchable="true"
                                placeholder="กรุณาเลือกหน่วยงาน"
                                :class="{ 'border-1 border-theme-24 rounded-md': validate.agency.$error}"
                                label="min_name"
                                :reduce="label => label"
                            >
                                <template #open-indicator="{ attributes }">
                                    <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                                </template>
                                <template #no-options="">
                                    <p class="text-sm font-normal text-gray-500">
                                        ไม่พบข้อมูล
                                    </p>
                                </template>
                            </v-select>
                            <template v-if="validate.agency.$error">
                                <div class="text-theme-24 mt-1 text-xs">
                                {{validate.agency.required.$message}}
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="form-inline mt-5">
                        <label for="sub-agency" class="form-label sm:w-40">หน่วยงานย่อย</label>
                        <input id="sub-agency" type="text" v-model="planForm.sub_org_name" class="form-control" placeholder="ระบุหน่วยงานย่อย" />
                    </div>
                </div>
            </slot>
        </modal-layout>
         <!-- <modal-layout v-model="modalView" :headerTitle="`แผนและการติดตามผลการดำเนินงานเพื่อแก้ไขปัญหา: ${titleModal}`" :id="'view-tracking-process'" isViewOnly :isSentOtherSystem -->
        <modal-layout v-model="modalView" :headerTitle="`แผนและการติดตามผลการดำเนินงานเพื่อแก้ไขปัญหา: ${titleModal}`" :id="'view-tracking-process'" isViewOnly :isSentOther="isSentOther()" @click:SentOtherConnection="handleSelectToSentOtherConnection('not_yet')" @update:modelValue="handleModalClose">
            <!-- <div class="flex flex-row justify-end items-center mb-4 ">
                <button class="btn btn-primary" @click="sendSolutionToWelfare">
                    ส่งแผนการให้ความช่วยเหลือไปที่ระบบจัดสวัสดิการครบวงจร
                </button>
            </div> -->
            <slot>
                <div class="mb-1"><h2 class="text-base font-bold">ข้อมูลแผนการช่วยเหลือ</h2></div>
                <div class="box mb-4 rounded-md relative border-1 border-[#a1a1a1] bg-primary-1/[.3] h-full" v-if="planData">
                    <div class="header p-3 border-b-1 font-bold">
                        <div class="flex">
                            <label for="plan-category" class="mr-2 sm:w-40 text-primary-1">วันที่สร้างแผน</label>
                            <div class="flex-1">
                                {{thaiDate(planData.sol_date)}}
                            </div>
                        </div>
                    </div>
                    <div class="font-medium p-3 py-5">
                        <div class="flex mb-2">
                            <label for="plan-category" class="mr-2 sm:w-40 text-primary-1">ประเภทแผน</label>
                            <div class="flex-1">
                                {{planData.plan_duration ? getThaiPlanDuration(planData.plan_duration) : "-"}}
                            </div>
                        </div>
                        <div class="flex mb-2">
                            <label for="plan-category" class="mr-2 sm:w-40 text-primary-1">ประเภทแนวทางการแก้ไข</label>
                            <div class="flex-1">
                                {{planData.sol_type}}
                            </div>
                        </div>
                        <div class="flex mb-2">
                            <label for="plan-category" class="mr-2 sm:w-40 text-primary-1">แนวทางการแก้ไข</label>
                            <div class="flex-1">
                                {{ getPlanTitle(planData) }}
                            </div>
                        </div>
                        <div class="flex mb-2">
                            <label for="plan-category" class="mr-2 sm:w-40 text-primary-1">รายละเอียด</label>
                            <div class="flex-1">
                                {{planData.sol_detail ? planData.sol_detail : "-"}}
                            </div>
                        </div>
                        <div class="flex mb-2">
                            <label for="plan-category" class="mr-2 sm:w-40 text-primary-1">หน่วยงานที่ส่งต่อ</label>
                            <div class="flex-1">
                                {{planData.main_org_name ? planData.main_org_name : "-"}}
                            </div>
                        </div>
                        <div class="flex mb-2">
                            <label for="plan-category" class="mr-2 sm:w-40 text-primary-1">หน่วยงานย่อย</label>
                            <div class="flex-1">
                                {{planData.sub_org_name ? planData.sub_org_name : "-"}}
                            </div>
                        </div>
                        <div class="flex mb-2" v-show="typeof planData.sent_other_system !== 'undefined' && !planData.sent_other_system.includes('not_sent')">
                            <label for="plan-category" class="mr-2 sm:w-40 text-primary-1">สถานะการส่งไประบบอื่น</label>
                            <div class="flex-1">
                                <ol v-html="generateShowSentOtherSystem(planData.sent_other_system)"></ol>
                            </div>
                        </div>
                        <!-- <div class="flex mb-2" v-show="typeof planData.sent_other_system !== 'undefined' && planData.sent_other_system == 'not_sent'">
                            <label for="plan-category" class="mr-2 sm:w-40 text-primary-1">สถานะการส่งไประบบอื่น</label>
                            <div class="flex-1">
                                {{planData.sent_other_system}}
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="mb-1" v-if="viewList.length > 0"><h2 class="text-base font-bold">ข้อมูลการติดตามการดำเนินการ</h2></div>
                <!-- <div class="box mb-4 rounded-md relative border-1 border-[#a1a1a1] bg-[#f2f2f2] h-full" :class="{ 'bg-[#f8fff4]': item.activity_type === 'assist' }" v-for="item in viewList" :key="item">
                    <div class="header p-3 border-b-1 font-bold">
                        <div class="flex">
                            <label for="plan-category" class="mr-2 sm:w-40 text-primary-1">{{item.activity_type === 'assist' ? "วันที่ช่วยเหลือ": "วันที่ติดตาม"}}</label>
                            <div class="flex-1">
                                {{thaiDate(item.activity_type === 'assist' ? item.assist_date : item.act_date)}}
                            </div>
                           <div 
                            v-if="item.data_source"
                            class="px-3 py-1 mr-2 text-white text-xs font-medium rounded-full"
                            style="background-color: #f32b8e;">
                            {{item.data_source}}
                            </div>
                            <div
                                class="dropdown inline-block"
                                data-placement="bottom-end"
                                v-if="getAllowActionByCurrRole('delete-problem-plan') && viewList.sol_status != 2 && viewList.prob_status != 3"
                            >
                                <button
                                    class="dropdown-toggle"
                                    aria-expanded="false"
                                >
                                    <MoreHorizontalIcon class="!stroke-3 p-1"/>
                                </button>
                                <div class="dropdown-menu rounded-md custom-width">
                                    <div class="dropdown-menu__content box dark:bg-dark-1 rounded overflow-hidden">
                                        <a
                                            href="#"
                                            class="block flex items-center p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-[#ddd] dark:hover:bg-dark-2 p-2 text-red"
                                            data-dismiss="dropdown"
                                            @click="deleteActivity(item)"
                                        >
                                            <Trash2Icon class="w-4 h-4 mr-1"/> ลบ
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="font-medium p-3 py-5">
                        <div class="flex mb-2" v-for="category in planCategoryDescription(item.activity_type)" :key="category.property">
                            <label for="plan-category" class="mr-2 sm:w-40 text-primary-1">{{ category.name }}</label>
                            <div class="flex-1">
                                {{item[category.property] ?? "-"}}{{item[category.property] && category.name === "จำนวนเงินที่ได้รับ" ? " บาท" : ""}}
                            </div>
                        </div>
                        <div class="flex mb-2" v-if="item.act_image">
                            <label for="plan-category" class="mr-2 sm:w-40 text-primary-1">รูปภาพ</label>
                            <div class="flex-1">
                                <ImageItem :item-list="mapNewData(item.act_image)"/>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="box mb-4 rounded-md relative border-1 border-[#a1a1a1] h-full" 
     :class="{ 
        'bg-[#f8fff4]': ['assist', 'voc_training'].includes(item.activity_type),
        'bg-[#f2f2f2]': !['assist', 'voc_training'].includes(item.activity_type)
     }" 
     v-for="item in viewList" :key="item.id"> <div class="header p-3 border-b-1 font-bold">
        <div class="flex">
            <label class="mr-2 sm:w-40 text-primary-1">
                {{ 
                    item.activity_type === 'assist' ? "วันที่ช่วยเหลือ" : 
                    item.activity_type === 'voc_training' ? "วันที่เริ่มการอบรมอาชีพ" : 
                    item.activity_type === 'voc_follow' ? "วันที่ติดตามหลังการฝึกอบรมอาชีพ" : 
                    "วันที่ติดตาม" 
                }}
            </label>

            <div class="flex-1">
                {{ 
                    thaiDate(
                        item.activity_type === 'assist' ? item.assist_date : 
                        item.activity_type === 'voc_training' ? item.votr_date_start : 
                        item.act_date
                    ) 
                }}
            </div>

            <div v-if="item.data_source"
             class="px-3 py-1 mr-2 text-white text-xs font-medium rounded-full h-fit"
             style="background-color: #f32b8e;align-self: flex-start;">
            {{item.data_source}}
        </div>

            <div class="dropdown inline-block"
                 v-if="getAllowActionByCurrRole('delete-problem-plan') && viewList.sol_status != 2 && viewList.prob_status != 3">
                <button class="dropdown-toggle"><MoreHorizontalIcon class="!stroke-3 p-1"/></button>
                <div class="dropdown-menu rounded-md custom-width">
                    <div class="dropdown-menu__content box dark:bg-dark-1 rounded overflow-hidden">
                        <a href="#" class="block flex items-center p-2 text-red" @click="deleteActivity(item)">
                            <Trash2Icon class="w-4 h-4 mr-1"/> ลบ
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="font-medium p-3 py-5">
        <div class="flex mb-2" v-for="category in planCategoryDescription(item.activity_type)" :key="category.property">
            <label class="mr-2 sm:w-40 text-primary-1">{{ category.name }}</label>
            <div class="flex-1">
                <!-- {{ item[category.property] ?? "-" }} {{item[category.property] && (category.name === "จำนวนเงินที่ได้รับ" || category.property === "vofo_monthly_income")? " บาท" : ""}} -->
            <template v-if="category.isDate">
        {{ thaiDate(item[category.property]) || "-" }}
    </template>
    
    <template v-else>
        {{ item[category.property] ?? "-" }}
        {{ item[category.property] && (category.name === "จำนวนเงินที่ได้รับ" || category.property === "vofo_monthly_income") ? " บาท" : "" }}
    </template>
            </div>
        </div>

        <div class="flex mb-2" v-if="item.act_image">
            <label class="mr-2 sm:w-40 text-primary-1">รูปภาพ</label>
            <div class="flex-1">
                <ImageItem :item-list="mapNewData(item.act_image)"/>
            </div>
        </div>
    </div>
</div>
            </slot>
        </modal-layout>
        <modal-layout v-model="modalTrackingStatus" :headerTitle="`เพิ่ม ${titleModal}`" @click:save="handleSaveActModal" @click:cancel="clearActModal" :id="'tracking-process'" :isDone="isDone" :isDisabledSubmit="!currentBtnStatus || validatePlan.$invalid" v-if="getAllowActionByCurrRole('create-problem-plan')">
            <slot>
                <div>
                    <div class="form-inline items-baseline">
                        <label for="plan-category" class="form-label sm:w-40">วันที่ติดตาม<span class="text-red"> *</span></label>
                        <div class="flex-1">
                            <div>
                                <Datepicker
                                    v-model="validatePlan.act_date.$model"
                                    data-test="tracking-date"
                                    :enableTimePicker="false"
                                    :monthChangeOnScroll="false"
                                    selectText="ตกลง"
                                    cancelText="ยกเลิก"
                                    locale="th"
                                    :month-year-component="monthYear"
                                    :format="format"
                                    :previewFormat="format"
                                    :maxDate="new Date()"
                                    preventMinMaxNavigation
                                    :yearRange="[1900, new Date().getFullYear()]"
                                    :class="{ 'border-1 border-theme-24 rounded-md': validatePlan.act_date.$error}"
                                ></Datepicker>
                            </div>
                             <template v-if="validatePlan.act_date.$error">
                                <div
                                    v-for="(error, index) in validatePlan.act_date.$errors"
                                    :key="index"
                                    class="text-theme-24 mt-1 text-xs"
                                >
                                    {{ error.$message }}
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="form-inline mt-5 items-start">
                        <label for="horizontal-form-2" class="form-label sm:w-40">ขั้นตอน/กระบวนการช่วยเหลือ<span class="text-red"> *</span></label>
                        <div class="flex-1">
                            <textarea id="horizontal-form-2" v-model="validatePlan.act_procedure.$model" placeholder="กรุณาระบุขั้นตอน/กระบวนการช่วยเหลือ" class="form-control" style="min-height: 100px;resize: none;" :class="{ 'border-1 border-theme-24 rounded-md': validatePlan.act_procedure.$error}"/>
                            <template v-if="validatePlan.act_procedure.$error">
                                <div class="text-theme-24 mt-1 text-xs">
                                {{validatePlan.act_procedure.required.$message}}
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="form-inline mt-5 items-baseline">
                        <label for="horizontal-form-2" class="form-label sm:w-40">ผลความช่วยเหลือ<span class="text-red"> *</span></label>
                        <div class="flex-1">
                            <v-select
                                data-test="result-change"
                                v-model="validatePlan.act_progression.$model"
                                :options="['อยู่รอด', 'พอเพียง', 'ยั่งยืน', 'อื่นๆ']"
                                :clearable="false"
                                :searchable="false"
                                placeholder="กรุณาเลือกผลความช่วยเหลือ"
                                :class="{ 'border-1 border-theme-24 rounded-md': validatePlan.act_progression.$error}"
                                label="label"
                            >
                                <template #open-indicator="{ attributes }">
                                    <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                                </template>
                            </v-select>
                            <template v-if="validatePlan.act_progression.$error">
                                <div class="text-theme-24 mt-1 text-xs">
                                {{validatePlan.act_progression.required.$message}}
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="form-inline mt-5 items-baseline">
                        <label for="horizontal-form-2" class="form-label sm:w-40">รายละเอียดการติดตาม</label>
                        <textarea id="horizontal-form-2" placeholder="กรุณาระบุรายละเอียดการติดตาม" class="form-control" style="min-height: 100px;resize: none;" v-model="actForm.act_detail"/>
                    </div>
                    <div class="form-inline mt-5 items-start">
                        <label for="horizontal-form-2" class="form-label sm:w-40">รูปภาพ</label>
                        <div class="flex-1">
                            <DropzoneUpload :data-info="memberInformation" @button-active-status="currentBtnStatus = $event" @complete-upload="actForm.act_image = $event" :uploadCancelEvent="!modalTrackingStatus"/>
                        </div>
                    </div>
                </div>
            </slot>
        </modal-layout>
    </template-layout>
</template>

<script setup>
import TemplateLayout from "@/layouts/side-menu/Main.vue";
// import CustomTab from "@/components/tabs/index.vue";
import PlanTab from "./container/PlanTab.vue";
import { computed, onMounted, reactive, ref, toRefs, defineAsyncComponent ,watch,nextTick} from "vue";
import modalLayout from "@/components/base/custom-modal/CustomModalLayout.vue";
import useVuelidate from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import dataProblemSolution from "@/data/mso-problem-solution.json";
import organize from "@/data/main_org.json";
import { useRoute } from "vue-router";
import Swal from "sweetalert2";
import { useStore } from "vuex";
import axios from "axios";
import CustomAccordion from "@/components/base/custom-accordion/index.vue";
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import DropzoneUpload from "@/components/dropzone-upload/index.vue";
import ImageItem from "@/components/image-item/index.vue";
import { getAllowActionByCurrRole } from "@/utils/get-roles";
import selectDataConnectionForSol from "./container/selectDataConnectionForSol.vue";
import solutionList from "@/data/solution_list.json";
import OtherSystemList from "@/data/other_system_list.json";

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})
const emit = defineEmits([
    'onClosed'
]);
const showConnectModal = ref(false);
const oldPlan= ref(false);
const dataOption = ref([])
const allowedSystems  = ref([])
const organizeOption = ref([])
const  isSelectedSystemsNotyet = ref(false)
organizeOption.value = organize.sort((a,b) => a.min_name > b.min_name ? 1 : -1 )
const problemProcessCategory = reactive([
    "ช่วยเหลือ",
    "ประสานส่งต่อ",
    "ให้คำแนะนำ"
])
const currentSummaryTabText = ref();
const currentSummaryTab = ref()
const modalStatus = ref(false)
const isDone = ref(false)
const route = useRoute()
const store = useStore()
const pageLoading = ref(false)
const memberInformation = ref()
const modalView = ref(false)
const viewList = ref([])
const titleModal = ref(null)
const MonthYear = defineAsyncComponent(() => import('@/components/custom-datepicker/monthComponent.vue'));
const monthYear = computed(() => MonthYear);
const format = (date) => {
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear() + 543;

    return `${day}/${month}/${year}`;
}
const planCategoryDescription = (activity_type) => {
    switch (activity_type) {
        case "assist":
            return [
                {
                    name: "เจ้าของเงินตามระเบียบ",
                    property: "assist_budget_owner"
                },
                {
                    name: "หน่วยงานที่จ่ายเงิน",
                    property: "assist_org"
                },
                {
                    name: "เจ้าหน้าที่วินิจฉัย",
                    property: "assist_approver"
                },
                {
                    name: "เจ้าหน้าที่ที่จ่ายเงิน",
                    property: "assist_payer"
                },
                {
                    name: "จำนวนเงินที่ได้รับ",
                    property: "assist_amount"
                },
                {
                    name: "แหล่งข้อมูล",
                    property: "data_source"
                },
            ];
    case "voc_training":
        return [
            { name: "หน่วยฝึกอาชีพที่อบรม", property: "votr_office_name" },
            { name: "หลักสูตรอบรม", property: "votr_course_name" },
            { name: "วันที่เริ่มการอบรม", property: "votr_date_start", isDate: true },
            { name: "วันที่จบการอบรม", property: "votr_date_finish", isDate: true },
            { name: "วันที่สมัคร", property: "votr_date_register", isDate: true },
            { name: "ชื่อเจ้าหน้าที่ที่ส่งข้อมูลการฝึกอบรม", property: "votr_officer" },
            { name: "วันที่จบหลักสูตร", property: "votr_date_course_finish", isDate: true },
            { name: "แหล่งข้อมูล", property: "data_source" }
        ];
    case "voc_follow":
        return [
            { name: "การทำงานหลังการอบรม", property: "vofo_employment" },
            { name: "รายได้หลังฝึกอาชีพ (บาท/เดือน)", property: "vofo_monthly_income" },
            { name: "ประโยชน์ที่ได้จากการฝึกอาชีพ", property: "vofo_training_benefit" },
            { name: "ชื่อ-นามสกุลของเจ้าหน้าที่ผู้ติดตาม", property: "act_by_name" },
            { name: "หน่วยงานของเจ้าหน้าที่ผู้ติดตาม", property: "act_by_org" },
            { name: "วันที่ติดตาม", property: "act_date", isDate: true },
            { name: "แหล่งข้อมูล", property: "data_source" }
        ];
        default:
        case "act":
            return [
                {
                    name: "ขั้นตอนกระบวนการ",
                    property: "act_procedure"
                },
                {
                    name: "ผลความช่วยเหลือ",
                    property: "act_progression"
                },
                {
                    name: "รายละเอียดการติดตาม",
                    property: "act_detail"
                },
                {
                    name: "เจ้าหน้าที่",
                    property: "act_by_name"
                },
                {
                    name: "หน่วยงาน",
                    property: "act_by_org"
                },
            ];
    }

};

const getPlanTitle = (plan) => {
  if (!plan) return "-";
  const mapped = solutionList.find((s) => s.sol_code === plan.sol_code);
  const solDes = plan.sol_des || mapped?.sol_des || "-";

  if (solDes === "อื่นๆ") {
    return plan.sol_other ? `${solDes} - ${plan.sol_other}` : solDes;
  }
  return solDes;
};

const currentBtnStatus = ref(true)
const planData = ref()
// const modalTrackingStatus = ref(false)
// const modalView = ref(false)
const actForm = reactive({
    act_date: new Date(),
    act_progression: null,
    act_procedure: null,
    act_detail: null
})
const currSolId = ref(null)
const modalTrackingStatus = ref(false)
const validateRules = {
    act_date: {
        required: helpers.withMessage(`กรุณาเลือกวันที่ติดตาม`, required)
    },
    act_progression: {
        required: helpers.withMessage(`กรุณาเลือกการเปลี่ยนแปลง`, required)
    },
    act_procedure: {
        required: helpers.withMessage(`กรุณาระบุขั้นตอน/กระบวนการช่วยเหลือ`, required)
    },
}
const validatePlan = useVuelidate(validateRules, toRefs(actForm), { $scope: false })

// const summaryTabChange = (tab) =>{
//   currentSummaryTab.value = tab.tab;
//   currentSummaryTabText.value = tab.text
// }
const planArray = reactive(
    [
        {tab: 'critical', name: 'แผนระยะวิกฤต'},
        {tab: 'short', name: 'แผนระยะสั้น'},
        {tab: 'continuous', name: 'แผนระยะต่อเนื่อง'},
    ])
const form = reactive({
    category: null,
    process: null,
    agency: null,
})
const planForm = reactive({
    sol_type: null,
    sol_code: null,
    sol_des: null,
    main_org_code: null,
    main_org_name: null,
    sol_other: null,
    sub_org_code: null,
    sub_org_name: null,
    sol_detail: null
})
const rules = {
    category: {
        required: helpers.withMessage(`กรุณาเลือกประเภทแนวทางการแก้ไข`, required)
    },
    process: {
        required: helpers.withMessage(`กรุณาเลือกแนวทางการแก้ไข`, required)
    },
    agency: {
        required: helpers.withMessage(`กรุณาเลือกหน่วยงาน`, required)
    },
}
const validate = useVuelidate(rules, toRefs(form), { $scope: false })
const clearModal = ()=>{
    form.category = null
    form.process = null
    form.agency = null
    planForm.sol_type = null
    planForm.sol_code = null
    planForm.sol_des =null
    planForm.main_org_code = null
    planForm.main_org_name = null
    planForm.sol_other = null
    planForm.sub_org_code = null
    planForm.sub_org_name = null
    planForm.sol_detail =  null
    planForm.sol_sys =  null
    isDone.value = false
    validate.value.$reset()
    modalStatus.value = false
    showConnectModal.value = false
    isSelectedSystemsNotyet.value = false
}
  const systemNames = OtherSystemList.reduce((acc, currentItem) => {
  acc[currentItem.field] = currentItem.name; 
  return acc;
})

const getUserInfo = (uid) =>{
    return new Promise((resolve, reject) => {
        const token = store.getters["userAuth/getToken"];
        const config = {
            url: `${process.env.VUE_APP_BASE_API}user/getUser`,
            method: 'POST',
            headers:{
                Authorization: `Bearer ${token}`,
                "Content-Type": `application/json; charset=utf-8`,
            },
            data: {
                uid: uid
            }
        };
        axios(config)
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        });
    })
}

function last2(val) {
  if (val == null || val === "") return "";
  const s = String(val).trim();
  return s.length >= 2 ? s.slice(-2) : s;
}
async function buildPayloadSentToVsmart() {
  const m = memberInformation.value;
  const plan = planData?.value;
  let userEnroll = { cid: "", firstname: "", lastname: "", provider_position_code: "", provider_position_name: "", office_id: "", officename: "" };
  try {
    const infoResult = await getUserInfo(store.getters["userAuth/getUsername"]);
    const u = infoResult?.[0];
    if (u) {
      userEnroll.firstname = u.name ?? "";
      userEnroll.lastname = u.surname ?? "";
      userEnroll.provider_position_name = u.position ?? "";
      userEnroll.office_id = u.organization?.org_code ?? "";
      userEnroll.officename = u.organization?.org_name ?? "";
    }
  } catch (_) {}
  const solDate = plan?.sol_date ? (typeof plan.sol_date === "string" ? plan.sol_date : new Date(plan.sol_date).toISOString()) : "";
  const datetimeSubmit = solDate ? convertISOToCompact(solDate) : "";
  const oneCourse = {
    learner_id: "",
    course_id: "",
    project_name: "",
    status_id: "",
    status_name: "",
    date_start: "",
    date_finish: "",
    office_id: "",
    office_name: "",
    coursecate_id: "",
    category_name: "",
    datetime_approve: "",
    data_wellfare: [
      {
        welfare_id: "",
        welfare_types_code: plan?.sol_code ?? "",
        welfare_types_name: plan?.sol_des ?? "",
        welfare_money_amount: null,
        datetime_submit: datetimeSubmit ?? "",
        user_enroll: userEnroll
      }
    ]
  };
  const oneProblem = {
    applicant_id: "",
    family_main_occupation: "",
    family_average_monthly_income: 0,
    income_source: "",
    formal_debt: 0,
    informal_debt: 0,
    welfare_benefits_received: "",
    welfare_received_amount: "",
    welfare_received_total_price: 0,
    welfare_received_detail: "",
    problem_situation: "",
    recieve_to_money: "",
    bank_name: "",
    bank_account_number: "",
    bookbank_upload: "",
    help_object: "",
    help_object_detail: "",
    help_other: "",
    help_other_detail: "",
    request_money_amount: 0,
    status_code: "",
    status_name: "",
    data_wellfare: null
  };
  if (!m) {
    return {
      cid: "", prename_code: "", prename: "", th_fname: "", th_lname: "", birthdate: "", eng_fname: "", eng_lname: "",
      marital_id: "", marital_name: "", education_id: "", education_name: "", gender_id: "", gender_name: "",
      address: "", moo: "", soi: "", road: "", muban: "", tambol_id: "", tambol_name: "", amphur_id: "", amphur_name: "",
      province_id: "", province_name: "", zipcode: "", mobile1: "", mobile2: "", email: "",
      nationality_id: "", nationality_name: "", race_id: "", race_name: "", religion_code: "", religion_desc: "",
      ethnicity_id: null, ethnicity_name: null,
      address_current: "", moo_current: "", soi_current: "", road_current: "", muban_current: "",
      current_tambol_id: "", current_tambol_name: "", current_amphur_id: "", current_amphur_name: "",
      current_province_id: "", current_province_name: "", zipcode_current: "",
      picture_upload: "", data_course: [oneCourse], data_problem: [oneProblem]
    };
  }
  return {
    cid: "",
    prename_code: "",
    prename: m.title ?? "",
    th_fname: m.name ?? "",
    th_lname: m.surname ?? "",
    birthdate: m.birthdate ?? "",
    eng_fname: "",
    eng_lname: "",
    marital_id: "",
    marital_name: m.marital_status ?? "",
    education_id: "",
    education_name: (m.edu_level && (typeof m.edu_level === "object" ? m.edu_level.desc : m.edu_level)) ?? "",
    gender_id: "",
    gender_name: m.sex ?? "",
    address: m.hnum ?? "",
    moo: m.moo ?? "",
    soi: m.soi ?? "",
    road: m.road ?? "",
    muban: m.village_name ?? "",
    tambol_id: last2(m.tumbol_code),
    tambol_name: m.tumbol_name ?? "",
    amphur_id: last2(m.amphur_code),
    amphur_name: m.amphur_name ?? "",
    province_id: m.province_code ?? "",
    province_name: m.province_name ?? "",
    zipcode: m.postcode ?? "",
    mobile1: m.mobile_num ?? "",
    mobile2: "",
    email: "",
    nationality_id: "",
    nationality_name: m.nationality ?? "",
    race_id: "",
    race_name: "",
    religion_code: "",
    religion_desc: m.religion ?? "",
    ethnicity_id: null,
    ethnicity_name: null,
    address_current: m.hnum ?? "",
    moo_current: m.moo ?? "",
    soi_current: m.soi ?? "",
    road_current: m.road ?? "",
    muban_current: m.village_name ?? "",
    current_tambol_id: m.tumbol_code ?? "",
    current_tambol_name: m.tumbol_name ?? "",
    current_amphur_id: m.amphur_code ?? "",
    current_amphur_name: m.amphur_name ?? "",
    current_province_id: m.province_code ?? "",
    current_province_name: m.province_name ?? "",
    zipcode_current: m.postcode ?? "",
    picture_upload: "",
    data_course: [oneCourse],
    data_problem: [oneProblem]
  };
}
const example_sent_to_dwf = reactive({
  personal_info: {},
  family_info: {},
  plan_info: null
});

async function buildPayloadSentToDwf() {
  const member = memberInformation.value;
  if (!member) return { personal_info: {}, family_info: {}, plan_info: null };
  const probKey = route.query.prob;
  const code = route.query.code;
  const summary = member.prob_summary;
  let plan_info = null;
  if (summary?.[probKey] && code) {
    const probIdx = summary[probKey].findIndex((x) => x.code === code);
    if (probIdx !== -1) {
      const probItem = summary[probKey][probIdx];
      plan_info = JSON.parse(JSON.stringify({
        code: probItem.code,
        desc: probItem.desc,
        status: probItem.status,
        plans: probItem.plans || []
      }));
      if (planData?.value?.sol_id && plan_info.plans?.length) {
        const planIdx = plan_info.plans.findIndex((x) => x.sol_id === planData.value.sol_id);
        if (planIdx !== -1) {
          plan_info.plans = [plan_info.plans[planIdx]];
        }
      }
    }
  }
  const familyInfo = example_sent_to_dwf.family_info && Object.keys(example_sent_to_dwf.family_info).length
    ? example_sent_to_dwf.family_info
    : {};
  return {
    personal_info: JSON.parse(JSON.stringify(member)),
    family_info: JSON.parse(JSON.stringify(familyInfo)),
    plan_info
  };
}
const convertISOToCompact = (isoString) => {
  if (!isoString) return null;
  
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return null;
  
  const pad = (num, length = 2) => num.toString().padStart(length, '0');
  
  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1);
  const day = pad(date.getUTCDate());
  const hour = pad(date.getUTCHours());
  const minute = pad(date.getUTCMinutes());
  const second = pad(date.getUTCSeconds());
  const ms = pad(Math.floor(date.getUTCMilliseconds() / 10));
  
  return `${year}${month}${day}${hour}${minute}${second}${ms}`;
};

// // ใช้งาน
// const isoDate = "2025-10-25T04:51:28.570Z";
// const compactDate = convertISOToCompact(isoDate);
// console.log(compactDate); // "20251025045128057"

const handleSelectToSentOtherConnection = async (isNotYet) => {
//  oldPlan.value = false
// let solCode = planData?.value?.sol_code;
//     const sentOtherSystemCodes = planData?.value?.sent_other_system || [];
//     if(!isNotYet){
//     validate.value.$touch();
//     }
//     if (validate.value.$invalid && isNotYet) {
//         if (sentOtherSystemCodes?.length === 0) {
//             return;
//         }
//         console.log(sentOtherSystemCodes)
//     } else {
//         const isFormValid = await validate.value.$validate();
//         if (!isFormValid) return;
//         solCode = planForm.sol_code;
//     };    
//     const currentSolution = solutionList.find(s => s.sol_code === solCode);
oldPlan.value = false;
    let solCode = planData?.value?.sol_code;
    const sentOtherSystemCodes = planData?.value?.sent_other_system || [];

    // 1.หา currentSolution ทันทีจาก solCode ตั้งต้น (เพื่อใช้เช็คว่าเป็น Plan เก่าหรือไม่)
    let currentSolution = solutionList.find(s => s.sol_code === solCode);

    // 2.ถ้า sent_other_system ยังไม่มีค่า (undefined) และ solution นี้มีระบบที่ต้องส่งต่อ
    if (typeof planData?.value?.sent_other_system === 'undefined' && currentSolution?.sol_sys?.length > 0) {
        oldPlan.value = true;
    }

    // 3.เข้าสู่กระบวนการ Validation
    if (!isNotYet) {
        validate.value.$touch();
    }

    if (validate.value.$invalid && isNotYet) {
        // เช็คต่อว่าถ้าไม่มีระบบส่งต่อเลยจริงๆ ค่อย return
        if (sentOtherSystemCodes?.length === 0 && !oldPlan.value) {
            return;
        }
        console.log(sentOtherSystemCodes);
    } else {
        const isFormValid = await validate.value.$validate();
        if (!isFormValid) return;
        
        // ถ้าผ่าน Validation ให้เปลี่ยน solCode เป็นค่าจาก Form
        solCode = planForm.sol_code;
        
        // 4. อัปเดต currentSolution อีกครั้งตามค่าใน Form (ถ้าเปลี่ยน sol_code ตัวแปรนี้ก็จะเปลี่ยนตาม)
        currentSolution = solutionList.find(s => s.sol_code === solCode);
    }
        if(sentOtherSystemCodes?.length > 0 && !sentOtherSystemCodes?.includes('not_sent')){
            const selectedSystemsSet = new Set(sentOtherSystemCodes);
allowedSystems.value = currentSolution?.sol_sys?.filter(system => {
    return !selectedSystemsSet.has(system);
});
            //  allowedSystems.value = sentOtherSystemCodes.map(sys => currentSolution?.sol_sys[sys] || sys);
        }else{
        allowedSystems.value = currentSolution?.sol_sys || [];
        }
    console.log( allowedSystems.value)
    if (!allowedSystems.value || allowedSystems.value?.length === 0) {
        await handleSaveModal(null);
        modalStatus.value = false;
        return;
    }
    showConnectModal.value = true;
};
const generateShowSentOtherSystem = (_array) => {
    if (!_array || _array.length === 0) {
            return ;
        }
    let _text = '';
    for (let i = 0; i < _array.length; i++) {
        const code = _array[i];
        const name = systemNames[code] || code;
        const dateIso = planData?.value?.sent_other_system_date
            ? planData.value.sent_other_system_date[code]
            : null;
        const dateText = dateIso ? thaiDate(dateIso) : null;

        _text += `<li>✅ ${name}`;
        if (dateText) {
            _text += ` <span style="color: grey;">(ส่งข้อมูล ${dateText})</span>`;
        }
        _text += `</li>`;
    }
    return _text;
}
const isSentOther = () => { 
console.log('isSentOther')
if (!planData?.value) {
        return false;
    }
let _array = planData?.value?.sent_other_system;
const currentSolution = solutionList.find(s => s.sol_code === planData?.value?.sol_code);
if (!_array || _array?.length === 0) {
    let _sol_sys = currentSolution?.sol_sys;
    if(_sol_sys || _sol_sys?.length > 0){
        return true
    }else{
        return false;
    }
}

if (_array.includes('not_sent')) {
            return true; 
}
//  const currentSolution = solutionList.find(s => s.sol_code === planData?.value?.sol_code);
 const missingSystems = currentSolution?.sol_sys.filter(system => !_array.includes(system));
let solCode = planForm?.sol_code;
        const planForm_currentSolution = solutionList.find(s => s.sol_code === solCode)?.sol_sys;
        console.log(planForm?.sol_code)
        if(missingSystems?.length > 0 || planForm_currentSolution?.length > 0){
            return true;
        }else{
            return false;
        }
// }
}
// const isSentOther = () => { 
// console.log('isSentOther')
// if (!planData?.value) {
//         return false;
//     }
// let _array = planData?.value?.sent_other_system;
// const currentSolution = solutionList.find(s => s.sol_code === planData?.value?.sol_code);
// if (!_array || _array?.length === 0) {
//     let _sol_sys = currentSolution?.sol_sys;
//     if(_sol_sys || _sol_sys?.length > 0){
//         return true
//     }else{
//         return false;
//     }
// }

// if (_array.includes('not_sent')) {
//             return true; 
// }
// //  const currentSolution = solutionList.find(s => s.sol_code === planData?.value?.sol_code);
//  const missingSystems = currentSolution?.sol_sys.filter(system => !_array.includes(system));
// let solCode = planForm?.sol_code;
//         const planForm_currentSolution = solutionList.find(s => s.sol_code === solCode)?.sol_sys;
//         console.log(planForm?.sol_code)
//         if(missingSystems?.length > 0 || planForm_currentSolution?.length > 0){
//             return true;
//         }else{
//             return false;
//         }
// // }
// }
const haveSameElements = (arr1, arr2) => {
    if (arr1?.length !== arr2?.length) {
        return false;
    }
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();
    return JSON.stringify(sortedArr1) === JSON.stringify(sortedArr2);
};
const handleAxiosSolUpdateSaveProbSummary = async (
  result,
  success_text,
  other_system,
  isSentOtherSystem,
  success_count
) => {
  isSelectedSystemsNotyet.value = false;
  const token = store.getters["userAuth/getToken"];

  if (!result.isConfirmed) {
    return;
  }

  let tempProb = JSON.parse(JSON.stringify(memberInformation.value)).prob_summary;
  const probIdx = tempProb[route.query.prob].findIndex((x) => x.code == route.query.code);
  const planIdx = tempProb[route.query.prob][probIdx].plans.findIndex(
    (x) => x.sol_id == planData?.value?.sol_id
  );

  let confirm_sent = false;
  const currentSolution = solutionList.find((s) => s.sol_code === planData?.value?.sol_code);

  if (planIdx !== -1) {
    // อัปเดต sol_sys ให้ตรงกับ solution ปัจจุบันถ้าไม่ตรงกัน
    if (
      currentSolution?.sol_sys &&
      !haveSameElements(
        currentSolution.sol_sys,
        tempProb[route.query.prob][probIdx].plans[planIdx].sol_sys
      )
    ) {
      tempProb[route.query.prob][probIdx].plans[planIdx].sol_sys = currentSolution.sol_sys;
      confirm_sent = true;
    }

    const targetObject = tempProb[route.query.prob][probIdx].plans[planIdx];
    let targetArray = targetObject.sent_other_system;
    if (!targetArray) {
      targetArray = [];
    }
    const sourceArray = other_system || [];
    const shouldReplace = targetArray?.includes("not_sent");

    if (shouldReplace) {
      targetObject.sent_other_system = sourceArray;
      confirm_sent = true;
    } else if (sourceArray.length > 0) {
      const targetSet = new Set(targetArray);
      const elementsToPush = sourceArray.filter((element) => !targetSet.has(element));
      if (elementsToPush.length > 0) {
        targetArray.push(...elementsToPush);
        targetObject.sent_other_system = targetArray;
        confirm_sent = true;
      }
    }

    // อัปเดตวันที่ส่งแผนไปยังแต่ละระบบ (เก็บครั้งแรกของแต่ละระบบ)
    if (Array.isArray(sourceArray) && isSentOtherSystem && sourceArray.length > 0) {
      const nowIso = new Date().toISOString();
      if (!targetObject.sent_other_system_date || typeof targetObject.sent_other_system_date !== "object") {
        targetObject.sent_other_system_date = {};
      }
      sourceArray
        .filter((system) => system !== "not_sent")
        .forEach((system) => {
          if (!targetObject.sent_other_system_date[system]) {
            targetObject.sent_other_system_date[system] = nowIso;
          }
        });
      confirm_sent = true;
    }

    const config = {
      url: `${process.env.VUE_APP_BASE_API}member/${route.params.mid}`,
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": `application/json; charset=utf-8`,
      },
      data: {
        update: {
          prob_summary: tempProb,
        },
      },
    };

    if (!confirm_sent) {
      return;
    }

    try {
      await axios(config);
      // โหลดข้อมูลล่าสุด
      await getMemberInformation();

      // รีเฟรชแผนปัจจุบันบน modal จาก sol_id เดิม
      if (memberInformation.value?.prob_summary && planData?.value?.sol_id) {
        const probKey = route.query.prob;
        const code = route.query.code;
        const summary = memberInformation.value.prob_summary;

        if (summary[probKey]) {
          const newProbIdx = summary[probKey].findIndex((x) => x.code === code);
          if (newProbIdx !== -1) {
            const probItem = summary[probKey][newProbIdx];
            const newPlan =
              probItem.plans?.find((x) => x.sol_id === planData.value.sol_id) ??
              probItem.plans?.[probItem.plans.length - 1];
            if (newPlan) {
              planData.value = newPlan;
              getViewList(newPlan, probItem.status);
            }
          }
        }
      }

      if (success_count !== 0) {
        // กรณีส่งข้อมูลอย่างเดียว บรรทัดแรกตรงกลาง (ส่งสำเร็จ/มีบางระบบไม่สำเร็จ/ส่งไม่สำเร็จ)
        const idx = success_text.indexOf("\n");
        const summaryLine = idx >= 0 ? success_text.slice(0, idx) : "";
        const statusBlock = idx >= 0 ? success_text.slice(idx + 1) : success_text;
        const htmlText = summaryLine
          ? `<div style="text-align: center;">${summaryLine}</div><div style="text-align: left; margin-top: 0.75em;">${statusBlock.replace(/\n/g, "<br>")}</div>`
          : (statusBlock ? `<div style="text-align: left;">${statusBlock.replace(/\n/g, "<br>")}</div>` : "");
        await swalCustom.fire({
          html: htmlText,
          icon: typeof success_count === "string" ? success_count : undefined,
          timer: 3000,
          confirmButtonText: "ปิด",
        });
        // ค้าง modalView ไว้ ไม่ปิด แต่บันทึกสถานะว่าเสร็จแล้ว
        isDone.value = true;
      }
      return 200;
    } catch (error) {
      console.log(error);
      await swalCustom.fire({
        text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
        icon: "warning",
        confirmButtonText: "ปิด",
      });
      isDone.value = true;
      // กรณี error ให้รีเฟรชข้อมูล แต่ไม่ปิด modalView
      await getMemberInformation();
      return 500;
    }
  }
}
  const handleAxiosSolUpdateSave = async (result,success_text,other_system,isSentOtherSystem, success_count) => {
                let infoResult = await getUserInfo(store.getters["userAuth/getUsername"])
        let currDate = new Date()
        let planFormSolSys = planForm.sol_sys;
        if(!planForm.sol_sys){
             const currentSolution = solutionList.find(s => s.sol_code === planForm?.sol_code);
             planFormSolSys = currentSolution?.sol_sys || null
        }
        let planObject = {
                sol_id: `sol${currDate.getFullYear()}${("0" + (currDate.getMonth() + 1)).slice(-2)}${("0" + currDate.getDate()).slice(-2)}${("0" + (currDate.getHours())).slice(-2)}${("0" + currDate.getMinutes()).slice(-2)}${("0" + currDate.getSeconds()).slice(-2)}${currDate.getMilliseconds()}`,
                sol_type: planForm.sol_type,
                sol_code: planForm.sol_code,
                sol_des: planForm.sol_des,
                sol_other: planForm.sol_other,
                sol_detail: planForm.sol_detail,
                sol_sys: planFormSolSys,
                sol_date: new Date().toISOString(),
                sol_by_user: store.getters["userAuth/getUsername"],
                sol_by_name: infoResult[0] ? `${infoResult[0].title}${infoResult[0].name} ${infoResult[0].surname}` : null,
                sol_by_org: infoResult[0].organization ? infoResult[0].organization.org_name : null,
                main_org_code: planForm.main_org_code,
                main_org_name: planForm.main_org_name,
                sub_org_code: planForm.sub_org_code,
                sub_org_name: planForm.sub_org_name,
                status: 0,
                plan_duration: currentSummaryTab.value,
            }
              if (Array.isArray(other_system) && other_system.length > 0 && isSentOtherSystem) {
      planObject.sent_other_system = other_system;
      // บันทึกวันที่ส่งแผนไปยังแต่ละระบบ
      const nowIso = new Date().toISOString();
      const systemsForDate = other_system.filter(sys => sys !== "not_sent");
      if (systemsForDate.length > 0) {
        planObject.sent_other_system_date = {};
        systemsForDate.forEach(sys => {
          planObject.sent_other_system_date[sys] = nowIso;
        });
      }
    }
               //get index of prob in prob_summary then check has key plans 
        let tempProb = JSON.parse(JSON.stringify(memberInformation.value))
        let probIdx = tempProb.prob_summary[route.query.prob].findIndex(x=>x.code == route.query.code)
        
        //have plan and no activity then change prob status to 1 and prevent update prob status when prob status is 3
        if(tempProb.prob_summary[route.query.prob][probIdx].status == 0){
            tempProb.prob_summary[route.query.prob][probIdx].status = 1 //add plan set prob status
        }
              if(tempProb.prob_summary[route.query.prob][probIdx].plans){
            tempProb.prob_summary[route.query.prob][probIdx].plans.push(planObject)
        }
        else{
            let arrPlan = []
            arrPlan.push(planObject)
            tempProb.prob_summary[route.query.prob][probIdx].plans = arrPlan
        }
        // swalCustom.fire({
        //     text:"ยืนยันบันทึกข้อมูล",
        //     icon:"info",
        //     showCancelButton: true,
        //     reverseButtons: true,
        //     confirmButtonText: 'ตกลง',
        //     cancelButtonText: 'ยกเลิก',
        // }).then((result)=>{
            // if(result.isConfirmed){
        console.log(infoResult)
        console.log(planObject)
        console.log(memberInformation.value)
        console.log(actForm)
        console.log(tempProb)
        //store.getters["userAuth/getUsername"
    //   if(result.isConfirmed){
         if(result.isConfirmed){
        let update_data = {
                            prob_summary: tempProb.prob_summary
                        };
                        console.log(other_system)
                 
                const token = store.getters["userAuth/getToken"];
                const config = {
                    url: `${process.env.VUE_APP_BASE_API}member/${route.params.mid}`,//'test_na_ja',
                    method: "PUT",
                    headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type": `application/json; charset=utf-8`,
                    },
                    data:{
                        update:update_data
                    }
                }
                return axios(config)
                .then(async () => {
                    await getMemberInformation();
                    if(success_count != 0){
                    // บันทึกอย่างเดียวไม่ส่ง
                    const htmlText = success_text
                      ? `<div style="text-align: center;">${success_text.replace(/\n/g, "<br>")}</div>`
                      : "";
                    swalCustom.fire({
                    html: htmlText,
                    icon: 'success',
                    timer: 3000,
                    confirmButtonText: "ปิด",
                    }).then(() => {
                        isDone.value = true
                        clearModal()
                    });}
                    return 200;
                })
                .catch((error) => {
                    // บันทึกไม่สำเร็จ
                    if (!(isSentOtherSystem && success_count === 0)) {
                      swalCustom.fire({
                        html: '<div style="text-align: center;">ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง</div>',
                        icon: "warning",
                        confirmButtonText: "ปิด",
                      }).then(() => {
                        isDone.value = true;
                        clearModal();
                        getMemberInformation();
                      });
                    }
                    console.log(error);
                    return 500;
                });
            }
        // });
    }

const handleSystemsSelected = (selectedSystems) => {
    console.log('Systems selected from CustomModalLayout:', selectedSystems);
    handleSaveModal(selectedSystems);
};
const handleSaveModal = async (selectedSystemsFromModal)=>{
    let selectedSystems = selectedSystemsFromModal
    isSelectedSystemsNotyet.value = false;
    console.log('planData')
    console.log(planData)
     const sentOtherSystemCodes = planData?.value?.sent_other_system
     if(typeof sentOtherSystemCodes != 'undefined' || oldPlan.value){
        if(selectedSystems?.includes('not_sent')){
            selectedSystems = sentOtherSystemCodes;
        }
        isSelectedSystemsNotyet.value = true;
    }else{
    validate.value.$touch()

    if(validate.value.$invalid){
        return ;
    }}
    oldPlan.value=false
        console.log(selectedSystems)

    try{
let success_text = "บันทึกข้อมูลสำเร็จ";
    let systemsToSend = null;
      if (!selectedSystems || selectedSystems === null) {
         swalCustom.fire({
        text: "ยืนยันบันทึกข้อมูล",
        icon: "info",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.isConfirmed) {
handleAxiosSolUpdateSave(result, success_text, null,false);
        }else{
 clearModal()
        }
      }); 
      return;
    }

  if (selectedSystems.includes("not_sent")) {
      swalCustom.fire({
        text: "ยืนยันบันทึกข้อมูล",
        icon: "info",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.isConfirmed) {
            if(!isSelectedSystemsNotyet.value){
          handleAxiosSolUpdateSave(result, success_text,selectedSystems,true);
            }
        }
      });
      return;
    }

const validSystems = selectedSystems.filter(sys => sys !== "not_sent");

    const selectedSystemNames = validSystems.map(sys => systemNames[sys] || sys).join(', ');
    success_text = `ส่งข้อมูลไปยัง ${selectedSystemNames} และบันทึกสำเร็จ`;
      let confirm_text =  `<div>ยืนยันบันทึกข้อมูล และส่งข้อมูลไปยัง</div><div class="font-bold mt-2">${selectedSystemNames}</div>`
    if(isSelectedSystemsNotyet.value){
        confirm_text=  `<div>ส่งข้อมูลไปยัง</div><div class="font-bold mt-2">${selectedSystemNames}</div>`
    }
swalCustom.fire({
      html: confirm_text,
      icon: "info",
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {  if(!isSelectedSystemsNotyet.value){
          systemsToSend = await handleAxiosSolUpdateSave(result, success_text, ["not_sent"], true, 0);
                }
        console.log(systemsToSend)
        if(systemsToSend != 200 && !isSelectedSystemsNotyet.value){
          // บันทึกไม่สำเร็จ จะไม่ส่งไประบบอื่น
          const saveLine = "บันทึกไม่สำเร็จ";
          const header = "สถานะการส่งข้อมูลไประบบอื่น";
          const lines = validSystems.map((sys) => {
            const name = systemNames[sys] || sys;
            return `❌ ${name}`;
          });
          const statusBlock = `${header}\n${lines.join("\n")}`;
          const htmlText = `<div style="text-align: center;">${saveLine}</div><div style="text-align: left; margin-top: 0.75em;">${statusBlock.replace(/\n/g, "<br>")}</div>`;
          swalCustom.fire({
            html: htmlText,
            icon: "error",
            confirmButtonText: "ปิด",
          });
          return;
        }
        if (systemsToSend === 200 && memberInformation.value?.prob_summary) {
          const probKey = route.query.prob;
          const code = route.query.code;
          const summary = memberInformation.value.prob_summary;
          if (summary[probKey]) {
            const probIdx = summary[probKey].findIndex((x) => x.code === code);
            if (probIdx !== -1 && summary[probKey][probIdx].plans?.length) {
              planData.value = summary[probKey][probIdx].plans[summary[probKey][probIdx].plans.length - 1];
            }
          }
        }
        {
        const promises = [];
const url_send2Ext = `${process.env.VUE_APP_BASE_API}dc/send2Ext`;
        for (const system of validSystems) {
          const token = store.getters["userAuth/getToken"];
          
          let apiConfig = null;
          
          switch (system) {
            case 'VSMART':
              apiConfig = {
                url: url_send2Ext,
                method: "POST",
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": `application/json; charset=utf-8`,
                },
                data: {
                  target_system: "vsmart",
                  payload: await buildPayloadSentToVsmart()
                }
              };
              break;              
            case 'DWF':
              apiConfig = {
                url: url_send2Ext,
                method: "POST",
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": `application/json; charset=utf-8`,
                },
                data: {
                  target_system: "dwf",
                  payload: await buildPayloadSentToDwf()
                }
              };
              break;
          }

          if (apiConfig) {
            promises.push(
              axios(apiConfig)
                .then(response => ({ system, success: true, response }))
                .catch(error => ({ system, success: false, error }))
                // .catch(error => ({ system, success: true, error }))
            );
          }
        }

      // ✅ รอให้ส่งข้อมูลไปทุกระบบเสร็จ
const results = await Promise.all(promises);

// ✅ แยกระบบที่สำเร็จและไม่สำเร็จ
const successSystems = results.filter(r => r.success).map(r => r.system);
const failedSystems = results.filter(r => !r.success).map(r => r.system);

console.log('Success systems:', successSystems);
console.log('Failed systems:', failedSystems);


const statusLines = validSystems.map((sys) => {
  const name = systemNames[sys] || sys;
  const isSuccess = successSystems.includes(sys);
  const mark = isSuccess ? "✅" : "❌";
  return `${mark} ${name}`;
});
const statusTextList = statusLines.join("\n");
const statusHeader = "สถานะการส่งข้อมูลไประบบอื่น";
const sendStatusText = `${statusHeader}\n${statusTextList}`;

let success_text = sendStatusText;
let systemsToSave = null;
let success_icon  = "success";
let success_text_later = sendStatusText;
let sendOnlyIcon = "success";

const totalSystems = validSystems.length;
const successCount = successSystems.length;

// ส่งอย่างเดียว icon ตามผลส่ง (success / error / warning)
const getSendOnlyIcon = () => {
  if (totalSystems === 0) return "success";
  if (successCount === totalSystems) return "success";
  if (successCount === 0) return "error";
  return "warning";
};
sendOnlyIcon = getSendOnlyIcon();

const sendOnlySummaryLine = sendOnlyIcon === "success" ? "ส่งสำเร็จ" : sendOnlyIcon === "warning" ? "มีบางระบบส่งข้อมูลไม่สำเร็จ" : "ส่งไม่สำเร็จ";
success_text_later = `${sendOnlySummaryLine}\n${sendStatusText}`;

// บันทึกสำเร็จแล้ว ถ้าส่งได้หมด success ส่งได้ไม่หมดหรือบางระบบ wrning
const getSendAndSaveIcon = () => {
  if (totalSystems === 0) return "success";
  if (successCount === totalSystems) return "success";
  return "warning";
};
success_icon = getSendAndSaveIcon();

if (successCount === 0) {
  systemsToSave = []; // ทุกระบบส่งไม่สำเร็จ
} else {
  systemsToSave = successSystems; // เก็บเฉพาะระบบที่ส่งสำเร็จ
}
console.log('4')
if (systemsToSave.length > 0) {
  if (isSelectedSystemsNotyet.value) {
    // ส่งข้อมูลอย่างเดียว
    await handleAxiosSolUpdateSaveProbSummary(
      result,
      success_text_later,
      systemsToSave,
      true,
      sendOnlyIcon
    );
  } else {
    // อัปเดต sent_other_system และ sent_other_system_date
    await handleAxiosSolUpdateSaveProbSummary(
      result,
      success_text_later,
      systemsToSave,
      true,
      0
    );
    const saveLine = "บันทึกสำเร็จ";
    const statusBlock = success_text ? success_text.replace(/\n/g, "<br>") : "";
    const htmlText = statusBlock
      ? `<div style="text-align: center;">${saveLine}</div><div style="text-align: left; margin-top: 0.75em;">${statusBlock}</div>`
      : "";
    swalCustom.fire({
      html: htmlText,
      icon: success_icon,
      timer: 3000,
      confirmButtonText: "ปิด",
    }).then(() => {
      isDone.value = true;
      isSelectedSystemsNotyet.value = false;
      clearModal();
      getMemberInformation();
    });
  }
} else {
  if (isSelectedSystemsNotyet.value) {
    // ส่งข้อมูลไม่สำเร็จทุกระบบ
    isSelectedSystemsNotyet.value = false;
    const idxLater = success_text_later.indexOf("\n");
    const summaryLineLater = idxLater >= 0 ? success_text_later.slice(0, idxLater) : "";
    const statusBlockLater = idxLater >= 0 ? success_text_later.slice(idxLater + 1) : success_text_later;
    const htmlTextLater = summaryLineLater
      ? `<div style="text-align: center;">${summaryLineLater}</div><div style="text-align: left; margin-top: 0.75em;">${statusBlockLater.replace(/\n/g, "<br>")}</div>`
      : (statusBlockLater ? `<div style="text-align: left;">${statusBlockLater.replace(/\n/g, "<br>")}</div>` : "");
    swalCustom.fire({
      html: htmlTextLater,
      icon: "error",
      confirmButtonText: "ปิด",
    });
  } else {
    // บันทึกและส่งได้หมด success ได้บางระบบ warning
    const saveLine = "บันทึกสำเร็จ";
    const statusBlock = success_text ? success_text.replace(/\n/g, "<br>") : "";
    const htmlText = statusBlock
      ? `<div style="text-align: center;">${saveLine}</div><div style="text-align: left; margin-top: 0.75em;">${statusBlock}</div>`
      : "";
    swalCustom.fire({
      html: htmlText,
      icon: success_icon,
      timer: 3000,
      confirmButtonText: "ปิด",
    }).then(() => {
      isDone.value = true;
      isSelectedSystemsNotyet.value = false;
      clearModal();
      getMemberInformation();
    });
  }
}
        }
      }
    }).catch((error) => {
        
    isSelectedSystemsNotyet.value = false
      console.log("Error! ", error);
      swalCustom.fire({
        text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
        icon: "warning",
        confirmButtonText: "ปิด",
      });
    });

  } catch (err) {
    
    isSelectedSystemsNotyet.value = false
    console.log("Error! ", err);
    swalCustom.fire({
      text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
      icon: "warning",
      confirmButtonText: "ปิด",
    });
  }
};

const getProcessSolution = (opt) =>{
    form.process = null
    form.agency = null
    dataOption.value = dataProblemSolution.filter(item => item.prob_code == route.query.code && item.sol_type == opt)
    let checkOther = dataOption.value.find((item)=>item.code == "OT")
    if(!checkOther){
        dataOption.value = [...dataOption.value, {sol_code: "OT", sol_des: "อื่นๆ",sol_type: opt}]
    }
}
const solutionSelected = (opt) =>{
    planForm.sol_type = opt.sol_type
    planForm.sol_code = opt.sol_code
    planForm.sol_des = opt.sol_des
    planForm.sol_sys = opt.sol_sys
    planForm.main_org_code = opt.main_org_code ? opt.main_org_code : null
    planForm.main_org_name = opt.main_org_name ? opt.main_org_name: null
    form.agency = opt.main_org_name ? opt.main_org_name : null
    planForm.sub_org_code = opt.sub_org_code ? opt.sub_org_code : null
    planForm.sub_org_name = opt.sub_org_name ? opt.sub_org_name : null
    console.log('solutionSelected - planForm updated:', planForm)
}
onMounted(() => {
  getMemberInformation();
});
const getMemberInformation = async () => {
  pageLoading.value = true;
  const token = store.getters["userAuth/getToken"];
  const url = `${process.env.VUE_APP_BASE_API}member/getMemberSurveyById`;
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": `application/json; charset=utf-8`,
  };
  const res = await axios
    .post(url, { memberId: route.params.mid }, { headers })
    .catch(() =>
      Swal.fire({
        icon: "warning",
        text: "ระบบผิดพลาด",
      })
    );
  pageLoading.value = false;
  if (res.status === 200) {
    memberInformation.value = res.data;
    if (res.data.fam_id) {
      await getFamilySurveyForDwf(res.data.fam_id);
    }
  } else {
    Swal.fire({
      icon: "warning",
      text: "ระบบผิดพลาด",
    });
  }
};

const getFamilySurveyForDwf = async (famId) => {
  const token = store.getters["userAuth/getToken"];
  const url = `${process.env.VUE_APP_BASE_API}family/getFamilySurveyById`;
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": `application/json; charset=utf-8`,
  };
  const res = await axios
    .post(url, { famId }, { headers })
    .catch(() => null);
  if (res?.status === 200 && res?.data) {
    example_sent_to_dwf.family_info = res.data;
  }
};

const breadcrumbComputed = computed(()=>{
  let array =[{
    name: "ครัวเรือน",
    path: "main-house-hold",
  }]
  if(memberInformation.value.hh_id){
    array.push({
      name: "ข้อมูลครัวเรือน",
      path: "household-profile",
      param: { hhid: memberInformation.value.hh_id },
    })
  }
  if(memberInformation.value.fam_id){
    array.push({
      name: "ข้อมูลครอบครัว",
      path: "family-profile",
      param: { famid: memberInformation.value.fam_id },
    })
  }
  if(memberInformation.value._id){
    array.push({
      name: "บุคคล",
      path: "member-profile",
      param: { mid: memberInformation.value._id },
    })
  }
  if(memberInformation.value.prob_summary){
    array.push({
      name: "สรุปสภาพปัญหา",
      active: true,
    })
  }
  return array
})
const getProbDesc = computed(()=>{
    if(memberInformation.value){
        let probIdx = memberInformation.value.prob_summary[route.query.prob].findIndex(x=>x.code == route.query.code)
        return memberInformation.value.prob_summary[route.query.prob][probIdx].desc
    }
    return null
})
const openViewModal = async (sol_data) =>{
    console.log('openViewModal')
    console.log(sol_data)
    planData.value = sol_data
    modalView.value = true
    console.log( modalView.value)
    currSolId.value = sol_data.sol_id
    let tempProb = JSON.parse(JSON.stringify(memberInformation.value))
    let probIdx = tempProb.prob_summary[route.query.prob].findIndex(x=>x.code == route.query.code)
    titleModal.value = tempProb.prob_summary[route.query.prob][probIdx].desc
    getViewList(sol_data, tempProb.prob_summary[route.query.prob][probIdx].status)
    // titleModal.value = `[${sol_data.sol_type}] - ${sol_data.sol_des == "อื่นๆ" ? sol_data.sol_des+' ( '+sol_data.sol_other+ ')' : sol_data.sol_des}`
}
const getViewList = (sol_data, prob_status) =>{
    viewList.value = []
    if(sol_data.activities){
        viewList.value = [...sol_data.activities]
        viewList.value["prob_status"] = prob_status
        viewList.value["sol_status"] = sol_data.status
        viewList.value = viewList.value.sort(function (a, b) {return new Date(b.act_date) - new Date(a.act_date)});
    }
    console.log(viewList.value)
}
const thaiDate = (dateValue) =>{
    if(dateValue){
        const date = new Date(dateValue);
        const result = date.toLocaleDateString("th-TH", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
        return result
    }
    else{
        return "-"
    }
}
const openAddModal = (sol_data) =>{
    modalTrackingStatus.value = true
    currSolId.value = sol_data.sol_id
    titleModal.value = `[${sol_data.sol_type}] - ${sol_data.sol_des == "อื่นๆ" ? sol_data.sol_des+(sol_data.sol_other ? ' ('+sol_data.sol_other+ ')' : '') : sol_data.sol_des}`
}

const handleSaveActModal = async ()=>{
    validatePlan.value.$touch()
    if(validatePlan.value.$invalid){
        return ;
    }
    try{
        let infoResult = await getUserInfo(store.getters["userAuth/getUsername"])
        let currDate = new Date()
        if(actForm.act_date){
            actForm.act_date = new Date(actForm.act_date)
            actForm.act_date.setUTCHours(0,0,0,0)
            actForm.act_date = actForm.act_date.toISOString()
        }
        let actObject = {
            activity_type: "act",
            act_id: `act${currDate.getFullYear()}${("0" + (currDate.getMonth() + 1)).slice(-2)}${("0" + currDate.getDate()).slice(-2)}${("0" + (currDate.getHours())).slice(-2)}${("0" + currDate.getMinutes()).slice(-2)}${("0" + currDate.getSeconds()).slice(-2)}${currDate.getMilliseconds()}`,
            act_date: actForm.act_date,
            act_procedure: actForm.act_procedure,
            act_progression: actForm.act_progression,
            act_detail: actForm.act_detail,
            act_by_user: store.getters["userAuth/getUsername"],
            act_by_name: infoResult[0] ? `${infoResult[0].title}${infoResult[0].name} ${infoResult[0].surname}` : null,
            act_by_org: infoResult[0].organization ? infoResult[0].organization.org_name : null
        }
        if(actForm.act_image){
            actObject.act_image = actForm.act_image
        }
        let tempProb = JSON.parse(JSON.stringify(memberInformation.value)).prob_summary
        let probIdx = tempProb[route.query.prob].findIndex(x=>x.code == route.query.code)
        let planIdx = tempProb[route.query.prob][probIdx].plans.findIndex(x=>x.sol_id == currSolId.value)
        //prevent update prob status when prob status is 3 but could still add activities
        if(tempProb[route.query.prob][probIdx].status != 3){
            tempProb[route.query.prob][probIdx].status = 2 //add activity set prob status
        }
        tempProb[route.query.prob][probIdx].plans[planIdx].status = 1 //add activity set plan status
        if(tempProb[route.query.prob][probIdx].plans[planIdx].activities){
            tempProb[route.query.prob][probIdx].plans[planIdx].activities.push(actObject)
        }
        else{
            let arrAct = []
            arrAct.push(actObject)
            tempProb[route.query.prob][probIdx].plans[planIdx].activities = arrAct
        }
        swalCustom.fire({
            text:"ยืนยันบันทึกข้อมูล",
            icon:"info",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก',
        }).then((result)=>{
            if(result.isConfirmed){
                const token = store.getters["userAuth/getToken"];
                const config = {
                    url: `${process.env.VUE_APP_BASE_API}member/${route.params.mid}`,
                    method: "PUT",
                    headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type": `application/json; charset=utf-8`,
                    },
                    data:{
                        update:{
                            prob_summary: tempProb
                        }
                    }
                }
                axios(config)
                .then(()=>{
                    swalCustom.fire({
                    text:"สำเร็จ",
                    icon: 'success',
                    timer: 3000,
                    confirmButtonText: "ปิด",
                    }).then(() => {
                        isDone.value = true
                        cash("#tracking-process").modal("hide");
                        clearActModal()
                        getMemberInformation()
                    });
                })
                .catch((error) => {
                    swalCustom.fire({
                        text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                        icon: "warning",
                        //timer: 3000, //timeOut for auto-close
                        confirmButtonText: "ปิด",
                    });
                    console.log(error);
                });
            }
        })
    }
    catch(error){
        console.log("Error! ",error);
        swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            // timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
        });
    }
}

const clearActModal = ()=>{
    actForm.act_date = new Date()
    actForm.act_progression = null
    actForm.act_procedure = null
    actForm.act_detail =  null
    isDone.value = false
    currSolId.value = null
    validatePlan.value.$reset()
    modalTrackingStatus.value = false
    if(actForm.act_image)
        actForm.act_image = null
}

const mapNewData = (dataList) =>{
    let result = [...dataList]
    result = result.map(item => ({...item, image_url: item.img_url, description: item.img_label}))
    return result
}
const deleteActivity = (data) =>{
    const token = store.getters["userAuth/getToken"];
    swalCustom.fire({
        text:"ยืนยันลบข้อมูล",
        icon:"warning",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
    }).then(async (result)=>{
        if(result.isConfirmed){
            //copy data for remove from array to save to api
            let tempProb = JSON.parse(JSON.stringify(memberInformation.value.prob_summary))
            let probIdx = tempProb[route.query.prob].findIndex(x=>x.code == route.query.code)
            let planIdx = tempProb[route.query.prob][probIdx].plans.findIndex(x=>x.sol_id == currSolId.value)
            let actIdx = tempProb[route.query.prob][probIdx].plans[planIdx]?.activities.findIndex((x) => {
                switch (x.activity_type) {
                    case "assist":
                        return x.assist_id === data.assist_id;
                    case "voc_training":
                        return x.assist_id === data.assist_id;
                    case "voc_follow":
                        return x.assist_id === data.act_id;
                    default:
                    case "act":
                        return x.act_id === data.act_id;
                }
            })
            if(actIdx != -1){
                tempProb[route.query.prob][probIdx].plans[planIdx].activities.splice(actIdx,1)
                if(tempProb[route.query.prob][probIdx].plans[planIdx].activities.length == 0){
                    //check each obj in plans have no activities
                    if(!tempProb[route.query.prob][probIdx].plans.some(obj=>obj.activities?.length>0)){
                        tempProb[route.query.prob][probIdx].status = 1 //set status if no activities
                    }
                    tempProb[route.query.prob][probIdx].plans[planIdx].status = 0
                    delete tempProb[route.query.prob][probIdx].plans[planIdx].activities
                }
                const config = {
                    url: `${process.env.VUE_APP_BASE_API}member/${route.params.mid}`,
                    method: "PUT",
                    headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type": `application/json; charset=utf-8`,
                    },
                    data:{
                        update:{
                            prob_summary: tempProb
                        }
                    }
                }
                axios(config)
                .then(()=>{
                    swalCustom.fire({
                    text:"สำเร็จ",
                    icon: 'success',
                    timer: 3000,
                    confirmButtonText: "ปิด",
                    }).then(() => {
                        //remove from array to update list in display preview modal
                        memberInformation.value.prob_summary[route.query.prob][probIdx].plans[planIdx].activities.splice(actIdx,1)
                        if(memberInformation.value.prob_summary[route.query.prob][probIdx].plans[planIdx].activities.length == 0){
                            memberInformation.value.prob_summary[route.query.prob][probIdx].plans[planIdx].status = 0
                            delete memberInformation.value.prob_summary[route.query.prob][probIdx].plans[planIdx].activities
                        }
                        getViewList(memberInformation.value.prob_summary[route.query.prob][probIdx].plans[planIdx])
                        //trigger api update plan data
                        getMemberInformation()
                    });
                })
                .catch((error) => {
                    swalCustom.fire({
                        text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                        icon: "warning",
                        //timer: 3000, //timeOut for auto-close
                        confirmButtonText: "ปิด",
                    });
                    console.log(error);
                });
            }
        }
    })
}

const closeCaseEvent = (data)=>{
    const token = store.getters["userAuth/getToken"];
    swalCustom.fire({
        html: `<div>ยืนยันการยุติความช่วยเหลือ</div><div><span class="font-bold">[${data.sol_type}]</span> ${data.sol_des == "อื่นๆ" ? data.sol_des+(data.sol_other ? ' - '+data.sol_other : '') : data.sol_des}</div>`,
        icon:"info",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
    }).then(async (result)=>{
        if(result.isConfirmed){
            let tempProb = JSON.parse(JSON.stringify(memberInformation.value)).prob_summary
            let probIdx = tempProb[route.query.prob].findIndex(x=>x.code == route.query.code)
            let planIdx = tempProb[route.query.prob][probIdx].plans.findIndex(x=>x.sol_id == data.sol_id)
            if(planIdx != -1){
                tempProb[route.query.prob][probIdx].plans[planIdx].status = 2
                const config = {
                    url: `${process.env.VUE_APP_BASE_API}member/${route.params.mid}`,
                    method: "PUT",
                    headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type": `application/json; charset=utf-8`,
                    },
                    data:{
                        update:{
                            prob_summary: tempProb
                        }
                    }
                }
                axios(config)
                .then(()=>{
                    swalCustom.fire({
                    text:"สำเร็จ",
                    icon: 'success',
                    timer: 3000,
                    confirmButtonText: "ปิด",
                    }).then(() => {
                        //trigger api update plan data
                        getMemberInformation()
                    });
                })
                .catch((error) => {
                    swalCustom.fire({
                        text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                        icon: "warning",
                        //timer: 3000, //timeOut for auto-close
                        confirmButtonText: "ปิด",
                    });
                    console.log(error);
                });
            }
        }
    })
}
const getThaiPlanDuration = (plan) =>{
    if(plan == "critical"){
        return "แผนระยะวิกฤต"
    }
    else if(plan == "short"){
        return "แผนระยะสั้น"
    }
    else{
        return "แผนระยะต่อเนื่อง"
    }
}

const sendSolutionToWelfare = async () => {
    const config = {
        url: "https://msoapi.wewasanad.org/",
        method: 'POST',
        headers: {
            "x-api-key": process.env.VUE_APP_WELFARE_TOKEN,
        },
        data: {
            "idCardNumber": memberInformation.value.national_id,
            "firstname": memberInformation.value.name,
            "lastname": memberInformation.value.surname,
            "welfareType": planData.value.sol_des,
            "province": memberInformation.value.province_name,
            "district": memberInformation.value.amphur_name,
            "subdistrict": memberInformation.value.tumbol_name,
            "logbookId": memberInformation.value._id,
            "username": store.getters["userAuth/getUsername"]
        },
    };
    try {
        const res = await axios(config);
        if (res.status === 201) {
            swalCustom.fire({
                text: "สำเร็จ",
                icon: "success",
                timer: 3000,
                confirmButtonText: "ปิด",
            });
        } else {
            Swal.fire({
                icon: "warning",
                text: "ระบบผิดพลาด",
            });
        }
    } catch (error) {
        console.log("Error ", error);
        swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            confirmButtonText: "ปิด",
        })
    }

};
// onMounted(() => {
// cash("#view-tracking-process").on('hidden.bs.modal', function () {
//  isSelectedSystemsNotyet.value = false
//         planData.value = null;
// });

// watch(modalView, async (newValue, oldValue) => {
//     console.log(modalView)
//     if (oldValue === true && newValue === false) {
//         await nextTick();
//     isSelectedSystemsNotyet.value = false
//      setTimeout(() => {
//         planData.value = null; 
//         }, 100);
//     } 
// });
const handleModalClose = (newValue) => {  
  if (!newValue) { 
    setTimeout(() => {
      isSelectedSystemsNotyet.value = false;
      planData.value = null;
    }, 400);
  }
};
// watch(modalStatus, (newValue, oldValue) => {
//     if (oldValue === true && newValue === false) {

//     clearModal()
//     }
// });
</script>

<style lang="scss">
.custom-width{
    width: 80px !important;
    min-width: 80px !important;
}

</style>